import React from "react";
import "./style.css";
import { useDispatch, useSelector } from "react-redux";
import { stringify } from "qs";
import isArray from "../../function/isArray";
import { pickUpInStore } from "../../models";

function ReservationPopup({ language }) {
  const product = useSelector(state => state.product.productBookingUnit);
  const details = useSelector(state => state.product.product);
  const toggleReservationPopup = useSelector(
    state => state.pickUpInStore.toggleReservationPopup
  );

  const _src = () => {
    const { code, productName1, productName2, productDesc } = details;
    const { discountPrice, media, origPrice } = product;
    const params = {
      code: code || "",
      name: `${productName1}|${productName2}` || "",
      desc: productDesc || "",
      price: discountPrice || origPrice || "",
      img: isArray(media.images) ? media.images[0].displayUrl : ""
    };
    const src = `/${language}/reserve-in-stock.html?${stringify(params)}`;
    return src;
  };

  const handleClose = () => {
    pickUpInStore.actions.setToggleReservationPopup(false);
    document.body.style.overflow = "";
  };

  return (
    <div
      className={`reservation-popup-wrap ${
        toggleReservationPopup ? "active" : ""
      }`}
      onClick={handleClose}
    >
      <div
        className="popup-container-wrap"
        onClick={e => {
          e.stopPropagation();
        }}
      >
        <div className="close-btn" onClick={handleClose} />
        <iframe src={_src()} />
      </div>
    </div>
  );
}

export default ReservationPopup;
